import { Box, Button, Grid2, Typography } from '@mui/material'
import { Constants } from '../../shared/constants'
import "@fontsource/roboto-slab";
import CustomDivider from '../../shared/utils/CustomDivider';

const CompetionCaraouselFirst = () => {
    return (
        <Grid2 container sx={{
            borderRadius: "20px", pt: { xs: 5, lg: 10 },
            backgroundImage: `url(${Constants.customImages.CompetitionCaraouselImg1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            height:"400px"
        }}

        >
            <Grid2 children size={{ xs: 12, md: 7 }} sx={{ display: "flex", flexDirection: "column", alignItems: "center", px: 2, pb: 3, m: "auto", position: "relative" }}>
                <Box
                    sx={{
                        clipPath: "polygon(13% 0, 78% 0, 69% 10%, 79% 20%, 11% 20%, 20% 11%)",
                        backgroundColor: "#025FC9",
                        width: "200px",
                        height: "200px",
                        display: "flex",
                        pt: 1,
                        justifyContent: "center",
                        position: "absolute",
                        pr: 3,
                          top:{xs: "-30px",lg:"-60px"},
                        zIndex: 1
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{ color: "primary.main", zIndex: 2 }}
                    >
                        Join the
                    </Typography>

                </Box>
                <Box
                    sx={{
                        clipPath: "polygon(0 0, 100% 0, 90% 10%, 100% 21%, 0 21%, 9% 11%)",
                        backgroundColor: "#025FC9",
                        width: "350px",
                        height: "200px",
                        display: "flex",
                        pt: 1,
                        justifyContent: "center",
                        position: "absolute",
                        top:{xs: "15px",lg:"0px"},
                        pr: 3,
                        zIndex: 1
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{ color: "primary.main", zIndex: 2 }}
                    >
                      Balloon Garland Challenge
                    </Typography>

                </Box>
                {/* <CustomDivider /> */}
                <CustomDivider size={"2rem"} />
                <Typography variant='body1' color='primary.main' my={3} textAlign={"center"}>
                    A balloon garland competition challenges participants to create the most creative, visually appealing, and well-constructed balloon garlands. Judging is often based on design, color coordination, technique, and overall presentation.
                </Typography>

                <Button variant='contained'>Know More</Button>
            </Grid2>
        </Grid2>
    )
}

export default CompetionCaraouselFirst;